import React from "react";
import { ReservationStatus } from "@/types/reservation";
import { cn } from "@/lib/utils";

type ReservationStatusVariant = "active" | "canceled" | "inactive";

const statusVariantConfig: Record<
  ReservationStatusVariant,
  {
    label: string;
    className: string;
    dotClassName: string;
  }
> = {
  active: {
    label: "Active",
    className: "border-emerald-100 bg-emerald-50 text-emerald-700",
    dotClassName: "bg-emerald-500",
  },
  canceled: {
    label: "Canceled",
    className: "border-red-100 bg-red-50 text-red-700",
    dotClassName: "bg-red-500",
  },
  inactive: {
    label: "Inactive",
    className: "border-zinc-200 bg-zinc-50 text-zinc-500",
    dotClassName: "bg-zinc-400",
  },
};

function getReservationStatusVariant(
  status: ReservationStatus,
): ReservationStatusVariant {
  if (status === ReservationStatus.CANCELLED) {
    return "canceled";
  }

  if (status === ReservationStatus.CHECKED_OUT) {
    return "inactive";
  }

  return "active";
}

export const StatusCell = ({ status }: { status: ReservationStatus }) => {
  const variant = getReservationStatusVariant(status);
  const config = statusVariantConfig[variant];

  return (
    <div className="flex items-center justify-center">
      <span
        className={cn(
          "inline-flex min-w-[76px] items-center justify-center gap-1.5 rounded-full border px-2 py-1 text-xs font-medium",
          config.className,
        )}
      >
        <span
          className={cn("size-2 rounded-full", config.dotClassName)}
          aria-hidden
        />
        {config.label}
      </span>
    </div>
  );
};
